module.exports = __webpack_public_path__ + "static/media/mobile-networking.943fdb82.jpg";